import React from 'react';

// ArtStation glyph (used in places where Lucide doesn't ship an icon)
export default function ArtStationIcon({ size = 14, className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M0 184.69l21.07 36.51c4.32 7.65 12.43 12.84 21.83 12.84h152.43l-28.46-49.35H0zm256-12.84a25.18 25.18 0 0 0-3.33-12.61L162.83 0l-43.78 75.86 56.13 96.99H256z" />
      <path d="M48.61 158.32h95.7l-47.85-82.84z" />
    </svg>
  );
}
